import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "svgicon" }

import InlineSvg from "vue-inline-svg";


export default /*@__PURE__*/_defineComponent({
  __name: 'svgIcon',
  props: {
    icon: {},
    size: { default: "30px" },
    path: { default: "icons" },
    color: { default: "currentColor" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v2ba384a7": (_ctx.size),
  "v47ee1f7d": (_ctx.color)
}))

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.icon)
      ? (_openBlock(), _createBlock(_unref(InlineSvg), {
          key: 0,
          src: require(`@/assets/${props.path}/${props.icon}.svg`)
        }, null, 8, ["src"]))
      : (_openBlock(), _createBlock(_unref(InlineSvg), {
          key: 1,
          src: require('@/assets/icons/no-image.svg')
        }, null, 8, ["src"]))
  ]))
}
}

})